import { PHOTO_BUTTON } from "../constants"
import AuthorElement from "./author-element"
import ButtonElement from "./button-element"
import CommentListElement from "./comment-list-element"
import ContainerElement from "./container-element"
import ImageElement from "./image-element"
import LoaderElement from "./loader-element"
import StarsElement from "./stars-element"
import TimestampElement from "./timestamp-element"
import TitleElement from "./title-element"
import FormCommentElement from "./form-comment-element"

/** @typedef {import('../bloc/photos-bloc').default} PhotosBloc */
/** @typedef {import('../bloc/photos-state').default} PhotosState */
/** @typedef {import('../models/photo-entity').default} PhotoEntity */

/**
 * @param {PhotoEntity} photo
 */
function pushNewStateToHistory(photo) {
  if (window.history.state === null || window.history.state.photoId !== photo.id) {
    const url = window.location.pathname
      .split("/")
      .slice(0, -1)
      .concat([photo.id.toString()])
      .join("/")
    window.history.replaceState({ photoId: photo.id }, "", url)
  }
}

/* eslint-disable no-underscore-dangle */
class View {
  /**
   * Creates an instance of View.
   * @param {PhotosBloc} context
   * @param {HTMLElement} htmlElement
   * @memberof View
   */
  constructor(context, htmlElement) {
    this._context = context

    this.loader = LoaderElement.fromHtmlElement(htmlElement)
    this.imageElement = ImageElement.fromHtmlElement(htmlElement)
    this.titleElement = TitleElement.fromHtmlElement(htmlElement)
    this.starsElement = StarsElement.fromHtmlElement(htmlElement)
    this.container = ContainerElement.fromHtmlElement(htmlElement)
    this.authorElement = AuthorElement.fromHtmlElement(htmlElement)
    this.timestampElement = TimestampElement.fromHtmlElement(htmlElement)
    this.commentListElement = CommentListElement.fromHtmlElement(htmlElement)
    this.formCommentElement = FormCommentElement.fromHtmlElement(htmlElement)

    this.buttonElementList = Array.from(htmlElement.querySelectorAll(PHOTO_BUTTON)).map(
      (buttonNode) => new ButtonElement(buttonNode, buttonNode.dataset.direction),
    )

    this.container.onClick(() => context.photosButtonsVisibilityUpdated())
    this.imageElement.onLoad(() => context.photosLoaded())
    this.buttonElementList.forEach((button) => {
      button.onClick((direction) => context.photosLoadRequested(direction))
    })
    this.starsElement.onSubmit((ratingOrNull) => {
      context.photosVoted(ratingOrNull)
    })
    this.commentListElement.onVote(context, context.state.currentPhoto)
  }

  /**
   * @param {PhotosState} state
   * @memberof View
   */
  update(state) {
    this.loader.toggleVisibility(state.loading)

    this.buttonElementList.forEach((button) => {
      button.toggleDisableState(state.loading)

      if (button.direction === "backward") {
        button.toggleVisibility(state.backwardPhoto === null)
      }

      if (button.direction === "forward") {
        button.toggleVisibility(state.forwardPhoto === null)
      }
    })

    if (state.currentPhoto !== null) {
      pushNewStateToHistory(state.currentPhoto)
      this.imageElement.apply(state.currentPhoto)
      this.titleElement.apply(state.currentPhoto)
      this.starsElement.apply(state.currentPhoto)
      this.authorElement.apply(state.currentPhoto)
      this.timestampElement.apply(state.currentPhoto)

      if (this.formCommentElement !== null) this.formCommentElement.apply(state.currentPhoto)

      this.commentListElement.apply(this._context, state.currentPhoto)
    }
  }
}

export default View
